<section class="maintenance-card">
  <p class="status-label">Maintenance</p>
  <h1>Le site AfriFood est temporairement indisponible.</h1>
  <p class="lead">
    Le web public est actuellement en maintenance. Les pages légales restent accessibles pendant
    cette période.
  </p>

  <div class="primary-action">
    <a
      href="https://play.google.com/store/apps/details?id=arnoarobase.cuisineafricaine"
      target="_blank"
      rel="noopener"
    >
      Télécharger l'application Android
    </a>
  </div>

  <div class="secondary-links">
    <a routerLink="/privacy-policy">Politique de confidentialité</a>
    <a routerLink="/data-deletion-request">Suppression des données</a>
  </div>
</section>
